/**
 * "Has this person seen X before?", for one-time explainers.
 *
 * Deliberately per-device rather than per-account: there is no server field for
 * it, the cost of being asked again on a second laptop is one dismissal, and a
 * migration for a hint is not a trade worth making. Same wrapping discipline as
 * the draft mirror — `localStorage` throws in a private window and when site
 * data is blocked, and a hint must never be the thing that takes a page down.
 *
 * Unset reads as *not* seen, so a blocked store means the explainer shows every
 * time. That is the right direction to fail: a repeated hint is a nuisance, a
 * first-run explainer that never appears is a feature nobody finds.
 */

const PREFIX = "roi:seen:";

export function hasSeen(flag: string): boolean {
  try {
    return window.localStorage.getItem(`${PREFIX}${flag}`) === "1";
  } catch {
    return false;
  }
}

export function markSeen(flag: string): void {
  try {
    window.localStorage.setItem(`${PREFIX}${flag}`, "1");
  } catch {
    // The hint shows again next time. Nothing else is lost.
  }
}

export function forgetSeen(flag: string): void {
  try {
    window.localStorage.removeItem(`${PREFIX}${flag}`);
  } catch {
    // Nothing to do.
  }
}

/** The flags in use, named here so two components cannot disagree on a string. */
export const SEEN_EDITOR_INTRO = "editor-intro";
